import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EventDateTime {
  Date: string,
  TimeEnd: string,
  TimeStart: string
}

export interface EventItems{ 
  AltText: string,
  BrowserTitle: string,
  Code: string,
  Country: string,
  DownloadDescription: string,
  DownloadLanguage: string,
  DownloadNumberOfPages: string,
  DownloadPath: string,
  DownloadSize: string,
  DownloadTitle: string,
  EventDateTime: EventDateTime[],
  EventOrganisationName: string,
  FormCode: string,
  FormEmail: string,
  HeaderImage: string,
  HeaderImageDescription: string,
  HeaderImageTitle: string,
  HeaderType: string,
  ItemImage: string,
  LanguageCode: string,
  Latitude: string,
  LocationName: string,
  Longitude: string,
  MainText: string,
  MetaDescription: string,
  MetaKeywords: string,
  MetaTitle: string,
  NameMenu: string,
  NameUrl: string,
  SiteUrl: string,
  StandNumber: string,
  StreetHouseNumber: string,
  ThumbnailAltText: string,
  ThumbnailPath: string,
  Title: string,
  UrlFreeTickets: string,
  UrlVisitor: string,
  Usp: string,
  ZipcodeCity: string
}

export const useEventOverviewStore = defineStore('eventOverview', {
  state: () => ({
    Code: '',
    LanguageCode: '',
    EventItems: [] as EventItems[],
    initialized: false,
    loading: false,
  }),

  getters: {
    getAll: (state) => () => {
      return state.EventItems;
    }
  },

  actions: {
    setInitialized(value: boolean) {
      this.initialized = value;
    },

    setLoading(value: boolean) {
      this.loading = value;
    },

    populate(eventItemsData : any) {
      if (!eventItemsData) {
        console.error('No eventItemsData included')
        return
      }

      // eventItemsData is een array
      if (Array.isArray(eventItemsData)) {
        this.Code = ''
        this.LanguageCode = ''
        this.EventItems = eventItemsData
        this.setInitialized(true)
        return
      }

      // eventItemsData is een Object met Code, LanguageCode en EventItems properties
      this.Code = eventItemsData.Code ? eventItemsData.Code : '';
      this.LanguageCode = eventItemsData.LanguageCode ? eventItemsData.LanguageCode : '';
      this.EventItems = Array.isArray(eventItemsData.EventItems) ? eventItemsData.EventItems : []
      this.setInitialized(true)
    },

    reset() {
      this.$reset()
      this.initialized = false
      this.loading = false
    }
  }
})

if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useEventOverviewStore, (import.meta as any).hot))
}